import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";
import { GRN } from "../interfaces/Grn";

// CREATE new GRN
export const createGRN = (payload: GRN) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/grns`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// GET all GRNs
export const getGRNs = (params={}) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/grns`, { params })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const getGRNById = (id: number) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/grns/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const updateGRN = (id: number | string, payload: GRN) => {
  return new Promise((resolve, reject) => {
    api
      .put(`${BASE_URL}/api/v1/grns/${id}`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

